import { useQuery } from 'react-query';
import { httpService } from '../../services/http.service';
import { BASE_URL, USER } from '../../constants/endpoints';
import { HOOKS_SETTINGS } from '../constants';

const { METHOD: { POST } } = HOOKS_SETTINGS;
const { CONTROLLERS: { TOGGLE_AUTO_SAVING: { BASE, VERSION } } } = USER;

export const useToggleAutoSavingsQuery = ({
  customerId, isAutoSaving, onSuccess, onFailure,
}: {customerId: string, isAutoSaving: boolean, onSuccess?: () => void, onFailure?: () => void }) => useQuery(
  ['toggleAutoSavings'],
  async () => {
    if (!customerId) {
      return '';
    }
    const { data } = await httpService({
      url: `${BASE_URL}/api/${VERSION}/user/${customerId}/${BASE}`,
      method: POST,
      data: {
        autoSave: isAutoSaving,
      },
    });
    return data;
  },
  {
    enabled: false,
    cacheTime: 2000,
    onSuccess: () => { if (onSuccess) onSuccess(); },
    onError: () => { if (onFailure) onFailure(); },
  },
);
